export default "__VITE_ASSET__8yiRbeRX__"